import React, { useState } from 'react';
import { MagnifierIcon } from '@increasecard/icons';
import { Chargeback } from '@card/types';
import { Grid, Modal, ModalContent, ModalHeader } from '@increasecard/typed-components';
import styled from 'styled-components';
import { formatDate } from '@card/commonlib';
import { useLocale } from '@increasecard/increase-core';
import { useTranslation } from 'react-i18next';

const Container = styled.div<{ withBorder?: boolean }>`
  border-right: ${(props) =>
    props.withBorder ? `1px solid ${props.theme.colorsNew.gray.grayMedium}` : 'none'};
`;

interface DetailsModalProps {
  chargeback: Chargeback;
}

const DetailsModal = ({ chargeback }: DetailsModalProps) => {
  const [showCustom, setShowCustom] = useState(false);
  const { t } = useTranslation();
  const locale = useLocale();
  const toggleCustom = () => {
    setShowCustom(!showCustom);
  };
  return (
    <>
      <button onClick={toggleCustom}>
        <MagnifierIcon height="18" width="18" />
      </button>
      <Modal
        onCancel={toggleCustom}
        onClose={toggleCustom}
        onOk={toggleCustom}
        visible={showCustom}
        width="450"
      >
        <ModalHeader>{t('chargebacks:modal:header')}</ModalHeader>
        <ModalContent>
          <Grid rowGap={2}>
            <Container className="grid-span-desktop-6" withBorder>
              <b>{t('chargebacks:modal:label:transaction_date')}</b>
              <p style={{ marginBottom: 20 }}>
                {locale ? formatDate(chargeback.transaction_date, locale) : '-'}
              </p>
              <b>{t('chargebacks:modal:label:voucher')}</b>
              <p style={{ marginBottom: 20 }}>{chargeback.voucher || '-'}</p>
              <b>{t('chargebacks:modal:label:batch_number')}</b>
              <p>{chargeback.batch_number || '-'}</p>
            </Container>
            <Container className="grid-span-desktop-6">
              <b>{t('chargebacks:modal:label:authorization_code')}</b>
              <p style={{ marginBottom: 20 }}>{chargeback.authorization_code || '-'}</p>
              <b>{t('chargebacks:modal:label:card_number')}</b>
              <p>
                {chargeback.card_number
                  ? chargeback.card_number.slice(chargeback.card_number.length - 4)
                  : '-'}
              </p>
            </Container>
          </Grid>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DetailsModal;
